// O estado e a querystring guardam ISO (`YYYY-MM-DD`); `dd/mm/aaaa` só na tela.
// Tudo com `Date` local e formatação manual: `new Date('2026-01-31')` é lido
// como UTC e `toISOString()` converte de volta, então em UTC-3 qualquer ida e
// volta por esse caminho devolveria o dia anterior.

const BR_DATE_LENGTH = 10;
const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

const pad = (value: number, size = 2) => `${value}`.padStart(size, '0');

export const maskBrDate = (raw: string): string => {
  const digits = (raw || '').replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

export const brDateToISO = (value: string): string => {
  if (!value || value.length !== BR_DATE_LENGTH) {
    return '';
  }

  const [day, month, year] = value.split('/').map(Number);

  if (!day || !month || !year || year < 1000) {
    return '';
  }

  const date = new Date(year, month - 1, day);

  // O `Date` aceita 31/02 e transborda para março; comparar os componentes de
  // volta é o que reprova uma data que não existe.
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return '';
  }

  return `${pad(year, 4)}-${pad(month)}-${pad(day)}`;
};

export const isoToBrDate = (value: string): string => {
  const match = ISO_DATE.exec(value || '');

  if (!match) {
    return '';
  }

  const [, year, month, day] = match;

  return `${day}/${month}/${year}`;
};

export const toISODate = (date: Date): string =>
  `${pad(date.getFullYear(), 4)}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const isoToDate = (value: string): Date | null => {
  const match = ISO_DATE.exec(value || '');

  if (!match) {
    return null;
  }

  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3]),
  );

  return Number.isNaN(date.getTime()) ? null : date;
};
